const primary = [

]

export default primary
